'use es6';

import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import BaseApp from 'ecosystem-marketplace-solutions-base/App';
import { setAppContext } from 'ecosystem-marketplace-solutions-base/actions/AppActions';
import { getAuth } from 'ecosystem-marketplace-solutions-base/actions/AuthActions';
import * as AppContext from 'ecosystem-marketplace-solutions-base/constants/AppContext';
import { setApiClient } from 'ecosystem-marketplace-solutions-base/utils/apiClient';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import rhumbConfig from '../rhumb-config.yaml';
import Application from './containers/Application';
export default class App extends BaseApp {
  initialize() {
    this.setAppContext();
    this.setApiClient();
    const [I18nProvider, langAvailable] = this.setupI18n();
    const authReady = this.store.dispatch(getAuth()).then(({
      user,
      portal
    }) => {
      I18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled,
        timezone: portal.timezone
      });
      Raven.setUserContext({
        id: user.user_id,
        email: user.email,
        locale: user.locale
      });
    });
    return Promise.all([authReady, langAvailable]);
  }
  setupI18n() {
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = this.registerI18n(I18nProvider);
    return [I18nProvider, langAvailable];
  }
  setApiClient() {
    setApiClient(http);
  }
  setAppContext() {
    this.store.dispatch(setAppContext(AppContext.IN_APP));
  }
  getRhumbConfig() {
    return rhumbConfig;
  }
  getApplicationComponent() {
    return Application;
  }
}